import React from 'react';
import Layout from '.';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import AuthWrapper from 'pages/auth/AuthWrapper';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';

export default function NotFound({ isLoggedIn }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return isLoggedIn ? (
    <Layout>
      <div className="no-page-found">
        <NoDataFound />
        <div>{t('HomePage.PageNotFound')}</div>
        <Button
          label={t('HomePage.BackToHome')}
          variant={'text'}
          onClick={() => navigate('/')}
        />
      </div>
    </Layout>
  ) : (
    <AuthWrapper page="pageNotFound">
      <div className="no-page-found">
        <NoDataFound />
        <div>Page not found</div>
        <Button
          label={'Back to login'}
          variant={'text'}
          onClick={() => navigate('/login')}
        />
      </div>
    </AuthWrapper>
  );
}
